import script from "./Radio.vue?vue&type=script&setup=true&lang=js"
export * from "./Radio.vue?vue&type=script&setup=true&lang=js"

import "./Radio.vue?vue&type=style&index=0&id=725655ae&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725655ae"]])

export default __exports__